/**
 * Maps a PCI Booking `cardType` / brand string (e.g. "Visa", "MasterCard", "American Express") to a
 * bundled brand-logo asset key (web: `client/src/ui/assets/card-brands/`, mobile: `mobile/src/ui/card-brand-svgs.ts`).
 * Returns undefined for unknown brands so the caller can fall back to a generic card icon. Shared here
 * (rather than duplicated per platform) so web and mobile recognize the exact same set of brands.
 */
const BRAND_ALIASES: Record<string, string> = {
  visa: 'visa',
  mastercard: 'mastercard',
  'master card': 'mastercard',
  amex: 'amex',
  'american express': 'amex',
  discover: 'discover',
  diners: 'diners',
  'diners club': 'diners',
  'diners club international': 'diners',
  jcb: 'jcb',
  unionpay: 'unionpay',
  'union pay': 'unionpay',
  'china unionpay': 'unionpay',
  maestro: 'maestro',
};

export function resolveCardBrandKey(brand: string | undefined): string | undefined {
  if (!brand) return undefined;
  return BRAND_ALIASES[brand.trim().toLowerCase()];
}
